<template>
    <div>
        <!--Used by Apple pay when payment sheet is active and desktop device-->
        <portal-target name="checkout-full-overlay"></portal-target>

        <div :class="{ 'show-checkout': open }" class="checkout" id="checkout-popup" data-test="checkout-modal">
            <error-popup></error-popup>

            <div
                :class="{
                    'checkout__content--with-keyboard': keyboardOpened,
                    'checkout__content--first-autofocus': firstAutofocus,
                }"
                class="checkout__content">
                <checkout-processing></checkout-processing>
                <div class="checkout__content-inner">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorPopup from './ErrorPopup.vue';
import CheckoutProcessing from './loaders/CheckoutProcessing.vue';

export default {
    components: {
        ErrorPopup,
        CheckoutProcessing,
    },
    props: {
        open: {
            required: true,
            type: Boolean,
        },
    },
    data() {
        return {
            keyboardOpened: false,
            firstAutofocus: false,
            temporaryDisableFirstAutofocus: false,
        };
    },
    mounted() {
        this.eventBus.on('OPEN_KEYBOARD', () => {
            this.keyboardOpened = true;
        });

        this.eventBus.on('CLOSE_KEYBOARD', () => {
            this.keyboardOpened = false;
            this.firstAutofocus = false;
        });

        this.eventBus.on('SET_FIRST_AUTOFOCUS', () => {
            if (!this.temporaryDisableFirstAutofocus) {
                this.firstAutofocus = true;
            } else {
                this.temporaryDisableFirstAutofocus = false;
            }
        });

        this.eventBus.on('TEMPORARY_DISABLE_FIRST_AUTOFOCUS', () => {
            this.temporaryDisableFirstAutofocus = true;
        });
    },
};
</script>
